export const isNumber = (unknown: unknown): unknown is number =>
  typeof unknown === 'number' && !Number.isNaN(unknown);
